import { List, ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import {
  Dashboard,
  HouseTwoTone,
  StarHalf,
  SupervisedUserCircle,
  VerifiedUser,
  VerticalSplit,
} from "@material-ui/icons";
import { useNavigate } from "react-router-dom";

const navList = [
  { id: 1, linkName: "Dashboard", navigate: "/dashboard", icon: <Dashboard /> },
  {
    id: 2,
    linkName: "Students",
    navigate: "/students",
    icon: <SupervisedUserCircle />,
  },
  {
    id: 3,
    linkName: "Teachers",
    navigate: "/dashboard",
    icon: <VerifiedUser />,
  },
  { id: 4, linkName: "Staff", navigate: "/dashboard", icon: <StarHalf /> },
  {
    id: 5,
    linkName: "Vehicle",
    navigate: "/dashboard",
    icon: <VerticalSplit />,
  },
];

const DrawerList = () => {
  const navigate = useNavigate();

  return (
    <List>
      {navList.map((items) => {
        return (
          <ListItem
            key={items.id}
            button
            onClick={() => navigate(items.navigate)}
          >
            <ListItemIcon>{items.icon}</ListItemIcon>
            <ListItemText>{items.linkName}</ListItemText>
          </ListItem>
        );
      })}
    </List>
  );
};

export default DrawerList;
